// extracted by mini-css-extract-plugin
export default {"noBackground":"iga-z","qnaContainer":"jga-z","qna":"kga-z","question":"lga-z","modal":"mga-z"};